import React, { useEffect } from 'react';
import {Route, Routes, BrowserRouter} from "react-router";
import IncidentReportForm_02 from './pages/IncidentReport/incidentReportForm_2.tsx';


import './App.css';

import Login from './layouts/Login.tsx';
import DashboardPage from './pages/ShopfloorclientSide/vehicle-models.tsx';
import VehicleInstructionsPage from './pages/NotInUse/work-instructions.tsx';
import BodyShopPage from './pages/NotInUse/body-shop.tsx';
import ChassisLinePage from './pages/NotInUse/chassis-line.tsx';
import TrimLinePage from './pages/NotInUse/trim-line.tsx';
import QITLinePage from './pages/NotInUse/qit-line.tsx';
import SavedInstructionsPage from './pages/NotInUse/saved-instructions.tsx';
import PaintShopPage from './pages/NotInUse/paint-shop.tsx';
import AdminDashboardPage from './pages/CRMview/ViewandAddModel.tsx';
import AddModelForm from './pages/NotInUse/AddModelForm.tsx';
import AddWorkStation from './pages/CRMview/AddWorkStation.tsx';
import WorkInstructionViewer from './pages/NotInUse/work-instruction-viewer.tsx';
import DynamicWorkstationPage from './pages/Verified/Dynamic-Page.tsx';
import WorkInstructionViewer01 from './pages/NotInUse/dynamic-work-instruction-viewer.tsx';
import AddBuilding from './pages/Verified/AddBuilding.tsx';
import ViewBuildings from './pages/Verified/ViewBuilding.tsx';
import CreateVehicleModel from './pages/Verified/CreateVehicleModel.tsx';
import SelectBuilding from './pages/CRMview/SelectBuilding.tsx';
import AddWorkStation01 from './pages/Verified/AddWorkStation01.tsx';
import AddWorkInstruction from './pages/Verified/AddWorkInstruction.tsx';
import SelectBuildingPage from './pages/Verified/SelectBuildingpage.tsx';
import AssignWorkstationsPage from './pages/Verified/AssignWorkStationsPage.tsx';
import BuildingWorkstationsPage from './pages/Verified/BuildingWorkStationPage.tsx';
import WorkInstructionsViewPage from './pages/Verified/workInstructionsView.tsx';
import PDFWorkInstructionViewer from './pages/Verified/PdfIWorkInstructionView.tsx';
import BuildProcessPage from './pages/Verified/BuildProcess.tsx';
import ProcessDocumentPage from './pages/Verified/ProcessDocument.tsx';
import AddModelPage from './pages/Verified/AddModal.tsx';
import DynamicWorkstationPage012 from './pages/ShopfloorclientSide/ClientDynamic-Page.tsx';
import BuildingWorkstationsPage01 from './pages/Verified/ClientBuildingWorkStationPage.tsx';
import WorkInstructionsViewPage001 from './pages/ShopfloorclientSide/ClientWorkInstructionsView.tsx';
import PDFWorkInstructionViewer001 from './pages/Verified/PdfDrawingsView.tsx';
import AdminLanding from './pages/landing-pageAdmin.tsx';
import BuildProcessClientPage from './pages/Verified/BuildProcessClient.tsx';
import OTPLogin from "./layouts/otpLogin.tsx";
import DesignDocumentPage from './pages/Verified/techspecpdf.tsx';
import Waiting from "./layouts/waiting.tsx";
import GenerateOTP from "./layouts/generateOTP.tsx";
import {Distruption} from "./layouts/distruption.tsx";
import IncidentWizard  from "./pages/IncidentReport/incidentwizard.tsx";
import IncidentLanding from "./pages/IncidentReport/IncidentLanding.tsx";
import IncidentDetail from './pages/IncidentReport/IncidentDetail.tsx';


function App() {
  return (

      <Routes>
        <Route
            path={"/:email"}
            element={<Waiting />}
        />
        <Route
            path={"/"}
            element={<GenerateOTP />}
        />
        <Route
            path={"/incidentReport-01"}
            element={<IncidentWizard />}
        />
        <Route
            path={"/incidentlanding"}
            element={<IncidentLanding />}
         />
         <Route
            path={"/incident-detail/:id"}
            element={<IncidentDetail />}
         />
        <Route
          path={"/otp"}
          element={<OTPLogin />}
        />
        <Route
            path={"/login"}
            element={<GenerateOTP />}
        />
        <Route
            path={"/login2"}
            element={<Login/>}
        />
        <Route
            path={"/distribute"}
            element={<Distruption/>}
        />
        <Route
            path={"/client/vehicle-models"}
            element={<DashboardPage />}
        />
        <Route
            path={"/admin-vehicle-models"}
            element={<AdminDashboardPage />}
        />
        <Route 
            path={"/admin/add-models"}
            element={<AddModelPage />}
        />
        <Route
            path={"/work-instructions"}
            element={<VehicleInstructionsPage vehicleId={''}/>}
        />
        <Route
            path={"/work-station/2"}
            element={<BodyShopPage/>}
        />
        <Route
            path={"/workstation/2"}
            element={<ChassisLinePage/>}
        />
        <Route
            path={"/workstation/4"}
            element={<TrimLinePage/>}
        />
        <Route
            path={"/workstation/5"}
            element={<QITLinePage/>}
        />
        <Route
            path={"/workstation/3"}
            element={<PaintShopPage/>}
        />
        <Route
            path={"/saved-instructions"}
            element={<SavedInstructionsPage/>}    
        />
        <Route 
            path="1/admin/add-model-form" 
            element={<AddModelForm />} 
        />
        <Route 
            path="1/admin/add-workstation/:modelId/:phase" 
            element={<AddWorkStation />} 
        />
        <Route
            path="1/admin/add-workstation//body-shop-model-work-instructions"
            element={<AddWorkStation/>}
        />
        <Route path="*" element={<div>404 Not Found</div>} /> 
        <Route
            path="/vehicle/:vehicleId"
            element={<DynamicWorkstationPage/>}
        />
        <Route path="/select-building" element={<SelectBuildingPage />} />
        <Route path="/assign-workstations/:buildingId" element={<AssignWorkstationsPage />} />
        <Route path="/add-building" element={<AddBuilding />} />
        <Route path="/view-buildings" element={<ViewBuildings />} />
        <Route path="/create-model" element={<CreateVehicleModel />} />
        <Route path="/select-building" element={<SelectBuilding />} />
        <Route path="/add-work-station/:buildingId/:vehicleModelId" element={<AddWorkStation01 />} />
        <Route path="/add-work-instruction/:vehicleModelId/:workStationId" element={<AddWorkInstruction />} />
        <Route path="/vehicle/:vehicleId/building/:buildingId" element={<BuildingWorkstationsPage />} />
        <Route path="/vehicle/:vehicleId/building/:buildingId/workstation/:workstationId/workinstruction/:instructionId" element={<PDFWorkInstructionViewer/>} />
        <Route path="/vehicle/:vehicleId/building/:buildingId/workstation/:workstationId/drawing/:instructionId" element={<PDFWorkInstructionViewer001/>} />
        <Route path="/vehicle/:vehicleId/building/:buildingId/workstation/:workstationId" element={<WorkInstructionsViewPage  />} />
        <Route path="/vehicle/:vehicleId/build-process" element={<BuildProcessPage />} />
        <Route path="/vehicle/:vehicleId/build-process-client" element={<BuildProcessClientPage />} />
        <Route path="/process-document/:docId" element={<ProcessDocumentPage />} />
        <Route path="/designSpec-document/:docId" element={<DesignDocumentPage />} />
        <Route path="/client/vehicle/:vehicleId" element={<DynamicWorkstationPage012 />} />
        <Route path="/client/vehicle/:vehicleId/building/:buildingId" element={<BuildingWorkstationsPage01 />} />
        <Route path="/client/vehicle/:vehicleId/building/:buildingId/workstation/:workstationId" element={<WorkInstructionsViewPage001  />} />
      </Routes>
    
  );
};

export default App;
